import { render, staticRenderFns } from "./SeminarTracker.vue?vue&type=template&id=660ff5bd&scoped=true&"
import script from "./SeminarTracker.vue?vue&type=script&lang=js&"
export * from "./SeminarTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660ff5bd",
  null
  
)

export default component.exports